































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { TaskItemForDB } from '@/types/type';
import { updateOrderForAll } from '@/utils/JobUtils';

@Component({
  components: { draggable },
})
export default class TaskList extends Vue {
  @Prop({ required: true })
  private readonly addedTasks!: TaskItemForDB[];

  private currentTasks: TaskItemForDB[] = [];

  created() {
    this.syncCurrentTasks();
  }

  @Watch('addedTasks', { immediate: true, deep: true })
  private syncCurrentTasks() {
    this.currentTasks = [...this.addedTasks];
  }

  private emitUpdatedTasks() {
    const updatedTasks = updateOrderForAll(this.currentTasks);
    this.$emit('updatedOrder', updatedTasks);
  }

  private removeTask(index: number) {
    this.currentTasks.splice(index, 1);
    this.emitUpdatedTasks();
  }

  private handleDragEnd() {
    this.emitUpdatedTasks();
  }

  private onDragStart(evt: any) {
    this.$emit('dragging', true);
    this.$emit('draggingItemIndex', evt.oldIndex);
  }

  private onDragEnd() {
    this.$emit('dragging', false);
    this.$emit('draggingItemIndex', null);
  }
}
